export const appSettingsConnectedContentCredentials = "/app_settings/connected_content_credentials";
